export const CASH_REDEMPTION_TYPE = 'LOYALTY_DOLLARS_AMOUNTS'
export const BIRTHDAY_REDEMPTION_TYPE = 'BIRTHDAY_REWARDS'
